<template>
    <article :class="classes" class="card article-main mb-3">
        <div v-if="article['pretitle']" class="card-header bg-white border-0 pb-0">
            <h5 aria-label="antetitulo">
                {{ article['pretitle'] }}
            </h5>
        </div>
        <div class="card-body">
            <div class="row no-gutters">
                <div class="col-12">
                    <h2 class="card-title" aria-label="titulo">
                        <a :href="articleUrl" target="_blank" class="clickable" :class="{'text-muted no-underline': !articleUrl}" ref="article_title">
                            {{ article['title'] }}
                        </a>
                    </h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h5 class="card-subtitle mb-2 text-muted" aria-label="fonte-original">{{ article['source'] }}, {{ article['year'] }}</h5>
                    <div class="card-text mb-2" aria-label="lead">
                        {{ article['snippet'] }}
                    </div>
                    <a :href="article['arquivo_source_url']" class="card-link small text-secondary" target="_blank">
                        <i class="fa fa-file-alt"></i> Fonte
                    </a>
                </div>
                <div v-if="article['img_url']" class="col-5 col-md-4" aria-label="fotografia">
                    <div class="article-img" :style="articleImgBackground" />
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import article from '@/mixins/article'
import '@/assets/article_animations.css'

export default {
    name: 'MainArticle',
    mixins: [
        article
    ]
}
</script>

<style scoped>
.card {
    z-index: 1000;
    border: 0;
}

.card-subtitle {
    font-size: 1.2rem;
}

.card-body {
    padding-top: 0;
}

.article-img {
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    height: 100%;
    min-height: 6rem;
}
</style>
